import { buildSlice, CommonState } from '~libs/reduxUtils';

import { PricePlan } from '~support-at-home/models';

import { getAll, getOne, typePrefix, update } from '~support-at-home/actions/pricePlans';

const initialState: CommonState<PricePlan> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  total: 0,
};

const slice = buildSlice<CommonState<PricePlan>, PricePlan>(typePrefix, initialState, {
  commonConfig: { getOne },
  customActions: {
    clearPlan(state) {
      state.row = undefined;
    },
    clearErrors(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, action) => {
      state.rows = action.payload.data;
      state.total = action.payload.total;
      state.loading = 'fulfilled';
      state.hasLoaded = true;
    });
    // The PUT /price-plans/:id response is { success, message } with no row payload, so sync the cached
    // row from the submitted arg (action.meta.arg). Only end_date is copied — it's the sole field this
    // endpoint mutates (start_date is model-protected server-side) — so the merge can't cache arbitrary
    // keys a caller might send. This keeps change-detection accurate on retry after a partial failure
    // (updatePlan ok, createRevision fails), avoiding a redundant no-op PUT and a spurious re-confirmation.
    builder.addCase(update.fulfilled, (state, action) => {
      if (!state.row) return;
      // Guard by plan id: update.fulfilled is a global slice case, so a late fulfillment must not patch
      // a row that has since been replaced (modal closed + a different plan opened before the PUT settled).
      const { id, end_date } = (action.meta.arg ?? {}) as Partial<PricePlan>;
      if (id === state.row.id && end_date !== undefined) state.row.end_date = end_date;
    });
  },
});

export const { clear, clearPlan, updateParams, clearErrors } = slice.actions;
export default slice.reducer;
